import { ChromePicker } from 'react-color';
import useToggle from '../../../hooks/useToggle';

const ColorPicker = ({
    name='', 
    value, 
    onSetValue,
    disableAlpha = true,
    onReset = false
}) => {
    const [displayPicker, togglePicker] = useToggle(false)

    const stylesColor = {
        background: value ? value : 'transparent',
    }

    return (
        <div className="color-picker color-picker-grid">

            <div className="color-picker-swatch cursor-pointer" onClick={togglePicker}>
                <div className="color-picker-color" style={stylesColor}/>
            </div>

            <div className="color-picker-settings">
                {name && <div className="text-small-light">{name}</div>}

                {displayPicker && <div className="color-picker-popup">
                    <div className="color-picker-cover" onClick={togglePicker}/>

                    <ChromePicker 
                        disableAlpha={disableAlpha}
                        color={value} 
                        onChange={onSetValue} 
                    />
                </div>}
            </div>

            {onReset && <div className="button button-reset cursor-pointer color-picker-reset" onClick={onReset}><span>Reset</span></div>}
        </div>
    )
}

export default ColorPicker